import { TankReadingsDiagnoseModal } from '@/pages/TankReadings'
import { MedicineBoxOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useState } from 'react'

interface DiagnoseTankCellProps {
  /** Source ID of the parent site mapping. */
  siteSourceId?: string | null
  /** Source ID of the tank row, which is the mapping's tank_id. */
  tankId?: string | null
  sourceSystem?: string | null
  isTank: boolean
}

/**
 * Opens the tank-readings diagnostic for one tank row of a site mapping. The
 * modal is mounted only while open so the detail grid doesn't carry an idle
 * query hook per tank row.
 */
export function DiagnoseTankCell({
  siteSourceId,
  tankId,
  sourceSystem,
  isTank,
}: DiagnoseTankCellProps) {
  const [open, setOpen] = useState(false)

  if (!isTank || !siteSourceId || !tankId) return null

  return (
    <>
      <Tooltip title='Diagnose tank readings'>
        <Button
          size='small'
          type='text'
          aria-label='Diagnose tank readings'
          icon={<MedicineBoxOutlined />}
          onClick={() => setOpen(true)}
        />
      </Tooltip>
      {open && (
        <TankReadingsDiagnoseModal
          open
          onClose={() => setOpen(false)}
          siteSourceId={siteSourceId}
          tankId={tankId}
          sourceSystem={sourceSystem ?? undefined}
        />
      )}
    </>
  )
}
